<template>
  <div class="sm-smart-mail__main-left-tpls">
    <div class="sm-smart-mail__main-left-rows">
      <div class="sm-smart-mail__main-left-row">
        <span class="sm-txt-strong">Mailbox {{pmb.pmb}}</span>
        <span 
          class="sm-smart-mail__main-left-row-status"
          :class="{
            'active': pmb.inactive == 'false'
          }"
        >{{pmb.inactive == 'false' ? 'Active' : 'Inactive'}}</span>
      </div>
      <div class="sm-smart-mail__main-left-row">
        <span>{{pmb.name}}</span>
        <span class="disabled">{{pmb.company}}</span>
      </div>
    </div>
    <div class="sm-smart-mail__main-left-search">
      <input-text
        v-model="mailSearch"
        :placeholder="'Search mail...'"
        :icon="'icon-search'"
        :class="{
          'disabled': !curMailTemplates.length && !mailSearch
        }"
      />
      <include-svg :name="'icon-search'" />
    </div>
    <ul
      v-if="curMailTemplates.length" 
      class="sm-smart-mail__main-left-list"
    >
      <li
        v-for="template in curMailTemplates"
        :key="template.id"
      >
        <div>
          <text-truncate :text="template.sender" />
          <span class="sm-txt-capitalize sm-small disabled">{{template.mail_type_name}}</span>
        </div>
        <a
          href="#"
          class="sm-link sm-sys"
          @click.prevent="$emit('template', template)"
        >Add</a>
      </li>
    </ul>
    <p
      v-else
      class="sm-smart-mail__main-left-empty"
    >
      <template v-if="!mailSearch">No templates available for <span class="sm-txt-strong">Mailbox#{{pmb.pmb}}</span></template>
      <template v-else>No templates for '{{mailSearch}}' in <span class="sm-txt-strong">Mailbox#{{pmb.pmb}}</span></template>
    </p>
  </div>
</template>

<script>
import InputText from '@/components/InputText';
import { mapActions } from 'vuex';
import Mail from '@/settings/mail';

export default {
  name: 'smart-mail-tpls',
  components: {
    'input-text': InputText
  },
  props: {
    pmb: {
      type: Object,
      required: true
    },
    mailList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      mailSearch: '',
      mailTemplates: []
    }
  },
  computed: {
    curMailTemplates() {
      let res = this.mailTemplates;

      if (this.mailList.length)
        res = res.filter(tpl => {
          return !this.mailList.some(item => item.id == tpl.id);
        });

      if (this.mailSearch) {
        let search = this.mailSearch.toLowerCase();
        res = res.filter(tpl => {
          if (
            tpl.id.toString().includes(search) ||
            tpl.mail_type_name.toLowerCase().includes(search) ||
            tpl.sender.toLowerCase().includes(search)
          )
            return true;

          return false;
        });
      }

      return res;
    }
  },
  created() {
    // show spinner
    this.getMailTemplates(this.pmb.pmb)
      .then(res => {
        this.mailTemplates = res.mail_items.map(item => {
          return {
            ...item,
            is_scannable: Mail.defaultScannableTypes.includes(item.mail_type_name.toLowerCase())
          };
        });
        
        // this.showSpinner =  false;
      });
  },
  methods: {
    ...mapActions({
      getMailTemplates: 'mail/getMailTemplates',
    })
  }
}
</script>